import { render, staticRenderFns } from "./SubscribedPeople.vue?vue&type=template&id=c0d7677e"
import script from "./SubscribedPeople.vue?vue&type=script&lang=js"
export * from "./SubscribedPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports